<template>
  <div class="findProjects">
    <leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" docutitle="手工录入项目"></leftnav>
    <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
      <govheader></govheader>
      <div class="index_left_centerpage">
        <findProjectsTab :current="1"></findProjectsTab>
        <div class="">
          <div class="whitebox">
            <div class="frame">
              <div class="projectMane_labelbox_pop">
                <div class="enterprisedetails project">
                  <el-form  label-position="left" label-width="100px" class="employer-ruleForm">
                    <!-- <el-row>
                      <el-col :span="24">
                        <el-form-item label="" label-width="120px">
                          <div>
                            <el-radio v-model="company" label="1">有项目公司</el-radio>
                            <el-radio v-model="company" label="2">暂无项目公司</el-radio>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row> -->
                    <!-- <el-row>
                      <el-col :span="24">
                        <el-form-item label="企业名称" required label-width="120px"> 
                            <seach v-show="company == '1'" @select="handleSelect" v-model="customerName" id="customerNameId1" ref="customerSearch"></seach>
                            <el-input v-show="company == '2'" v-model="customerName" placeholder="请输入项目名称" class="inp_text" id="customerNameId2" ref="customerInput"></el-input>
                          
                        </el-form-item>
                      </el-col>
                    </el-row> -->
                    <addProject :type="1" @postCusInfo="postCusInfo" cusid=""></addProject>
                    <!-- <el-row>
                      <el-col :span="24">
                        <el-form-item label="项目状态" required label-width="120px">
                          <el-select v-model="trackStatusvalue" placeholder="请选择"
                          ><el-option v-for="item in stausoptions" :key="item.value"
                        :label="item.label" :value="item.value">{{ item.label }}</el-option></el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="电 话" label-width="120px">
                          <el-input v-model="addphone" placeholder="请输入" class="inp_text"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="邮 箱" label-width="120px">
                          <el-input v-model="addemail" placeholder="请输入" class="inp_text"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="备 注" label-width="120px">
                          <textarea v-model="addremark" placeholder="请输入" class="inp_text"></textarea>
                        </el-form-item>
                      </el-col>
                    </el-row> -->
                  </el-form>
                  <!-- <div class="oh">
                    <el-button type="primary" class="fr" @click="addcus">保存</el-button>
                  </div> -->
                </div> 
                <div class="oh" v-show="erromsg.length > 0">
                  <h5 class="title labelfl fl"></h5>
                  <div class="labelfr fl">
                    <p class="errortips redfont">{{ erromsg }}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import seach from "./inc/seach.vue";
import addProject from "./inc/addProject.vue";
export default {
  name: "findProjects",
  computed: {
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
    ...mapGetters(['isCollapse']),
  },
  components: { seach,addProject },
  data() {
    return {
      userdata: { zsdn_version: 1, currentCity: { text: "全国" } },
      yj_mkcode: "E",
      yj_itemcode: "E-xlrxm",
      searchtext: "",
      
      company: '1',
      customerName: "",
      addphone: "",
      addemail: "",
      addremark: "",
      loading: false,
      erromsg: "",
      trackStatusvalue: "",
      stausoptions: [],
      customerdata: [],
      newadd: false,
      enterpriseOptions: [],
      showSuggestions: false, // 控制是否显示下拉建议
      cusid: '',
      
    };
  },
  created() {
    this.userdata = this.getuseriformation();
    this.getProjectStatus();
  },
  mounted() {
    
  },
  methods: {
    
  //获取项目状态
  getProjectStatus() { 
    let _this = this;
			let ajaxurl = this.$api.crm.parameter.projectStatus()+"?type=1";
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					let datalist = res.data.list;
					_this.stausoptions = datalist;
				}
			})
  },
    //负责人列表
		uniqueMid(arr) {
			const res = new Map();
			return arr.filter((arr) => !res.has(arr.managerId) && res.set(arr.managerId, 1));
		},
    postCusInfo(data) {
    },
    //监听搜索回车键
    searchenter(e) {
      if (e.keyCode == 13) {
        this.searchkwfun();
      }
    },
    //搜索关键词
    searchkwfun() { },

    handleSelect(item) {
      console.log('选中项数据:', item);
      this.customerName = item.title;
    },
    pageHandler: function (page) {
      this.page = page;
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input {
  font-size: 16px;
}
.inp_text{
  font-size: 16px;
}

.projectMane_labelbox_pop {
  width: 90%;
  padding: 30px;
}
.enterprisedetails{
  height: auto;
.project {
  height: auto;
}
}
.whitebox {
  min-height: 84vh;
}

</style>